import { getAuthToken, setAuthToken } from "./auth";

export const getApplication = async (id) => {
  try {
    const token = getAuthToken();

    const res = await fetch(`${api.url}/application/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : null,
      },
    });

    const data = await res.json();

    // New session
    if (res.status === 201) {
      setAuthToken(data.token);
      return null;
    }

    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateApplication = async ({ id, ...data }) => {
  try {
    const token = getAuthToken();

    if (!token) throw "No application token";

    await fetch(`${api.url}/application/${id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  } catch (error) {
    console.error(error);
  }
};

export const submitApplication = async (id) => {
  try {
    const token = getAuthToken();

    if (!token) throw "No application token";

    await fetch(`${api.url}/application/${id}/submit`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error(error);
  }
};
